import { withInstall } from '../../utils/install';
import RelativeTime from './index.vue';

export const IvueRelativeTime = withInstall(RelativeTime);
export default IvueRelativeTime;

export * from './index.vue';
